angular.module('app').factory('UserDetailsApi', function ($http, $q) {
    let userDetails = null;
    let fac = {
        get: get
    };
    function get() {
        // UserDetails is memoized => return as a promise
        if (userDetails) {
            let deferred = $q.defer();
            deferred.resolve(userDetails);
            return deferred.promise;
        }
        // Otherwise get it from the db
        return $http({
            method: 'GET',
            url: 'api/user/details',
            cache: true
        }).then(function (response) {
            return response;
        });
    }
    return fac;
});
